// extracted by mini-css-extract-plugin
export default {"container":"container-vOcjr","full":"full-mOMuB","inline":"inline-ia1fD","hidden":"hidden-C3G-U","spinnerShow":"spinnerShow-jiePp","load":"load-IaIHC","rotate":"rotate-GK1lD"};